import { LogEntry, LogStatus } from '../types'

const CLIENT_CODES = ['APP-WEB', 'APP-IOS', 'APP-AND', 'API-EXT', 'SYS-CRON']
const MESSAGES = [
  'Autenticación de usuario exitosa',
  'Error en el procesamiento de pago',
  'Tiempo de espera de conexión a base de datos',
  'Sincronización de datos completada',
  'Formato de datos inválido',
  'Límite de solicitudes excedido',
  'Fallo de caché, consultando base de datos',
  'Solicitud completada exitosamente',
]

const getStatusFromCode = (code: number): LogStatus => {
  if (code >= 200 && code < 300) return 'success'
  if (code >= 400) return 'error'
  return 'pending'
}

export const generateMockLog = (): LogEntry => {
  const isError = Math.random() > 0.8
  const statusCode = isError ? (Math.random() > 0.5 ? 500 : 404) : 200

  return {
    id: Math.random().toString(36).substring(7),
    timestamp: new Date().toISOString(),
    clientCode: CLIENT_CODES[Math.floor(Math.random() * CLIENT_CODES.length)],
    transactionId: `LOG-${Math.floor(Math.random() * 1000000)
      .toString()
      .padStart(6, '0')}`,
    statusCode,
    message: MESSAGES[Math.floor(Math.random() * MESSAGES.length)],
    responseTime: Math.floor(Math.random() * 1500) + 50,
    status: getStatusFromCode(statusCode),
    isNew: true,
  }
}

export const generateInitialLogs = (count: number): LogEntry[] => {
  return Array.from({ length: count }, () => {
    const log = generateMockLog()
    log.isNew = false
    const date = new Date()
    date.setMinutes(date.getMinutes() - Math.floor(Math.random() * 60))
    log.timestamp = date.toISOString()
    return log
  }).sort(
    (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
  )
}
